import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BRAND, { applyBrandToHead } from './brand'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/style.css'
import VueRource from 'vue-resource'
// import Swiper from 'swiper'
// import '../../node_modules/swiper/swiper-bundle.min.css'
import axios from "axios"

axios.defaults.timeout = 60 * 1000;

// import './assets/css/all.min.css'
// import './assets/css/aos.css'
// import './assets/css/css2.css'
// import './assets/css/style.scss'
// import './assets/js/aos.js'
// import './assets/js/script'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueRource)
// Vue.use(Swiper)

// 按访问域名写入品牌文案（title / keywords / description），配置见 src/brand.js。
// 本站目前只有一个域名，和 index.html 里写死的一致；保留这套机制是为了和 site-B 结构统一。
applyBrandToHead(BRAND)
Vue.prototype.$brand = BRAND

new Vue({
  render: h => h(App),
  router
}).$mount('#app')